import { Stack, Typography } from '@mui/material'
import { OrderResponseDto } from '@planning/app/api'
import { CargoTypeIconLabel } from '@planning/components/CargoTypeIconLabel'
import { useTranslate } from '@tolgee/react'
import { ArrowDownRightIcon, ArrowUpLeftIcon } from '@tom-ui/ui'
import { ReactNode, useMemo } from 'react'

interface Props {
  order: OrderResponseDto
  isFirst?: boolean
}
export const TruckVisitSearchCargoDetails = ({ order, isFirst }: Props) => {
  const { t } = useTranslate()

  const label = useMemo(() => {
    if (order.commodityId) {
      let label = order.commodityName
      if (order.referenceNumber) {
        label += ` - ${order.referenceNumber}`
      }

      return label ?? t('generalCargo', 'General Cargo')
    }

    return order.containerNumber ?? t('nonNumeric', 'Non-numeric')
  }, [order, t])

  const icon: ReactNode = useMemo(() => {
    if (!isFirst) return null

    if (order.direction === 'Inbound') {
      return <ArrowDownRightIcon />
    }

    return <ArrowUpLeftIcon />
  }, [isFirst, order.direction])

  return (
    <Stack direction={'row'} spacing={1}>
      {icon}
      <Stack direction='row' alignItems='center' spacing={1} paddingLeft={isFirst ? undefined : 4}>
        <CargoTypeIconLabel
          cargoType={order.commodityId ? 'GeneralCargo' : 'Container'}
          showLabel={false}
        />
        <Typography variant='body1'>{label}</Typography>
      </Stack>
    </Stack>
  )
}
